import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ViConfirmDialog {
  title: string;
  content: string;
  cancelBtn: string;
  confirmBtn: string;
}

@Component({
  selector: 'vi-notification-settings-dialog',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.scss'],
})
export class NotificationSettingsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {},
    public dialogRef: MatDialogRef<NotificationSettingsDialogComponent>
  ) {}

  onClose(): void {
    this.dialogRef.close(true);
  }
}
